import { generateRedirectionHTML, RedirectionProps } from "../generateRedirectionHTML";

export const generatePremiumRedirect = (redirectionProps: RedirectionProps): string => {
  return generateRedirectionHTML(
      {
        props: redirectionProps,
        id: "ROOT",
        isMainContainer: true
      }
    );
}